import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { getSupportStatus } from "@/lib/hours";

export function WhatsAppFloat() {
  const { settings, openWhatsApp } = useSettings();
  const [hover, setHover] = useState(false);
  const [st, setSt] = useState(() => getSupportStatus(settings));

  useEffect(() => {
    setSt(getSupportStatus(settings));
    const id = setInterval(() => setSt(getSupportStatus(settings)), 60000);
    return () => clearInterval(id);
  }, [settings]);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2">
      <div data-testid="whatsapp-status-pill" data-online={st.online}
        className={`flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full border shadow-lg backdrop-blur ${
          st.online ? "bg-emerald-500/15 border-emerald-500/30 text-emerald-200" : "bg-[#131C2E]/95 border-white/10 text-gray-300"}`}>
        <span className={`w-2 h-2 rounded-full ${st.online ? "bg-emerald-400 animate-pulse" : "bg-gray-500"}`} />
        <span data-testid="whatsapp-status-label">{st.label}</span>
      </div>
      <button
        onClick={() => openWhatsApp("floating")}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-testid="whatsapp-floating-btn"
        className={`ci-btn-wa ${st.online ? "ci-pulse" : ""} flex items-center gap-2 rounded-full text-white font-semibold shadow-xl hover:brightness-110 transition-all`}
        style={{ padding: hover ? "14px 20px" : "14px" }}
      >
        <MessageCircle className="w-6 h-6 shrink-0" />
        {hover && <span className="whitespace-nowrap pr-1 text-sm">{st.online ? "Precisa de ajuda?" : "Deixe sua mensagem"}</span>}
      </button>
    </div>
  );
}
